import Image from "next/image";
import {StaticImport} from "next/dist/shared/lib/get-img-props";
import { ReactNode} from "react";
import {getImage, FULL_WIDTH} from "@itchannelplus/utils/next-utils/image";
import {SectionContainer, SectionMarginValues} from "./styles";
import styles from "./styles.module.scss";
import { ImageProps } from "@itchannelplus/utils/next-utils/types";




export const Section = ({bgImage, children, className = '', style, margin = 'topLarge', ...props}:{bgImage?:string | StaticImport | ImageProps; children?: ReactNode, margin?:SectionMarginValues} &  React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) => {

  return <SectionContainer  className={`std-section ${styles.section}`} {...{margin}} {...props as any}>
         {bgImage && <Image src={getImage(bgImage)} alt={""} className={`std-section--bg-image ${styles.bgImage}`} fill sizes={FULL_WIDTH} />}
         <div className={`std-section--container container ${className}`} style={style}>
            {children}
         </div>
    </SectionContainer>
}
